var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWishlishHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.0497 5.76478C25.4112 5.12604 24.6532 4.61934 23.8189 4.27364C22.9845 3.92793 22.0903 3.75 21.1872 3.75C20.2841 3.75 19.3898 3.92793 18.5555 4.27364C17.7211 4.61934 16.9631 5.12604 16.3247 5.76478L14.9997 7.08978L13.6747 5.76478C12.385 4.47517 10.636 3.75067 8.81216 3.75067C6.98837 3.75067 5.23928 4.47517 3.94966 5.76478C2.66005 7.0544 1.93555 8.80349 1.93555 10.6273C1.93555 12.4511 2.66005 14.2002 3.94966 15.4898L5.27466 16.8148L14.9997 26.5398L24.7247 16.8148L26.0497 15.4898C26.6884 14.8513 27.1951 14.0933 27.5408 13.259C27.8865 12.4247 28.0644 11.5304 28.0644 10.6273C28.0644 9.72417 27.8865 8.82991 27.5408 7.99559C27.1951 7.16126 26.6884 6.40323 26.0497 5.76478Z",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishlishHeader);
export default __webpack_public_path__ + "static/media/wishlish-header.5def82c1ac6b39bd17ae47df3c842987.svg";
export { ForwardRef as ReactComponent };